import Vue from 'vue'
import { get } from 'lodash'
import { GET_USERS_INFO, GET_ACADEMY_USER_PROFILE } from '~/graphql/queries/users'
import defaultUserAvatar from '~/assets/images/default-avatar.png'

const mutationTypes = {
  SET_USERS_INFO: 'SET_USERS_INFO',
  SET_FETCHING_USERS_INFO: 'SET_FETCHING_USERS_INFO',
  SET_USER_PERSONAL_PROFILE: 'SET_USER_PERSONAL_PROFILE',
  SET_FETCHING_USER_PERSONAL_PROFILE: 'SET_FETCHING_USER_PERSONAL_PROFILE',
}
const actionTypes = {
  GET_USERS_INFO: 'GET_USERS_INFO',
  GET_ACADEMY_USER_PROFILE: 'GET_ACADEMY_USER_PROFILE',
}

export const state = () => ({
  usersInfo: {},
  fetchingInfo: false,
  userPersonalProfiles: {},
  fetchingUserProfiles: false,
})

export const mutations = {
  [mutationTypes.SET_FETCHING_USERS_INFO](state, fetchingInfo) {
    state.fetchingInfo = fetchingInfo
  },
  [mutationTypes.SET_USERS_INFO](state, usersInfo) {
    state.usersInfo = usersInfo
  },
  [mutationTypes.SET_USER_PERSONAL_PROFILE](state, userProfile) {
    Vue.set(state.userPersonalProfiles, userProfile.id, userProfile)
  },
  [mutationTypes.SET_FETCHING_USER_PERSONAL_PROFILE](state, fetchingInfo) {
    state.fetchingUserProfiles = fetchingInfo
  },
}

export const actions = {
  async [actionTypes.GET_ACADEMY_USER_PROFILE]({ state, commit }, personalProfileId) {
    const isExistProfile = get(state.userPersonalProfiles, personalProfileId, null)
    if (isExistProfile) {
      return
    }
    try {
      const client = this.app.apolloProvider.defaultClient
      const { data } = await client.query({
        query: GET_ACADEMY_USER_PROFILE,
        variables: { personalProfileId },
      })
      if (data.academyPersonalProfile) {
        commit(mutationTypes.SET_USER_PERSONAL_PROFILE, data.academyPersonalProfile)
      }
    } catch (error) {}
  },
  async [actionTypes.GET_USERS_INFO]({ commit, state, rootState }, { userIds, fetchNew = false }) {
    try {
      const filterIds = fetchNew
        ? userIds
        : Object.values(
            userIds.reduce((result, id) => {
              if (!state.usersInfo[id] || !result[id]) {
                result[id] = id
              }
              return result
            }, {})
          )

      if (filterIds.length < 1) {
        return []
      }

      commit(mutationTypes.SET_FETCHING_USERS_INFO, true)
      const client = this.app.apolloProvider.defaultClient
      const { data } = await client.query({
        query: GET_USERS_INFO,
        variables: {
          ids: filterIds,
          schoolId: rootState.school.schoolProfile.id,
        },
        fetchPolicy: 'no-cache',
      })
      if (data.usersInfo && Array.isArray(data.usersInfo)) {
        const usersInfo = data.usersInfo.reduce((result, userInfo) => {
          result[userInfo.id] = {
            ...userInfo,
            media: get(userInfo, 'media', { url: defaultUserAvatar }),
          }
          return result
        }, state.usersInfo)
        commit(mutationTypes.SET_USERS_INFO, usersInfo)
        commit(mutationTypes.SET_FETCHING_USERS_INFO, false)
        return data.usersInfo
      }
      throw data
    } catch (error) {
      commit(mutationTypes.SET_FETCHING_USERS_INFO, false)
      throw error
    }
  },
}

export const getters = {
  getUserInfo: (state) => (id) => {
    return state.usersInfo[id]
  },
  getUsersInfo: (state) => state.usersInfo,
  fetchingInfo: (state) => state.fetchingInfo,
  getUserPersonalProfile: (state) => (personalProfileId) => {
    return state.userPersonalProfiles[personalProfileId]
  },
  getPersonalProfileBySchoolId: (state, getters, rootState, rootGetters) => (userProfile) => {
    return (
      userProfile.personalProfiles.find(
        (profile) => get(profile, 'school.id', null) === rootGetters['school/schoolId']
      ) || null
    )
  },
}
